/**
 * Custom hook for accessing auction state
 */

import { useContext } from 'react';
import { AuctionContext } from '../context/AuctionContext';

/**
 * Hook for accessing global auction state
 * @returns {Object} Auction state and related data
 */
export const useAuctionState = () => {
  const { 
    auctionState, 
    currentDay, 
    totalSolRaised, 
    loading
  } = useContext(AuctionContext);
  
  return {
    auctionState,
    currentDay,
    totalSolRaised,
    loading
  };
};
